export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      // Captured BEFORE register(): sw.js calls skipWaiting()+clients.claim(),
      // so on first install controllerchange fires on a page that was never
      // controlled. Reloading there would force every first-time visitor
      // through a double page load.
      const hadController = Boolean(navigator.serviceWorker.controller)

      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      })

      console.log('Service Worker registered successfully:', registration)

      // Check for updates on page load
      registration.update()

      // Listen for service worker updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing

        if (newWorker) {
          console.log('New Service Worker found')

          newWorker.addEventListener('statechange', () => {
            console.log('Service Worker state:', newWorker.state)

            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker is available
              console.log('New Service Worker available, update pending')

              // Notify user about update
              const shouldUpdate = confirm(
                'Una nuova versione dell\'app è disponibile. Vuoi aggiornare ora?'
              )

              if (shouldUpdate) {
                newWorker.postMessage({ type: 'SKIP_WAITING' })
                window.location.reload()
              }
            }
          })
        }
      })

      // Handle controller change: reload ONLY when an existing controller is
      // replaced (a real update the user accepted), never on first install.
      let refreshing = false
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!hadController) return
        if (refreshing) return
        refreshing = true
        window.location.reload()
      })

      return registration
    } catch (error) {
      console.error('Service Worker registration failed:', error)
      throw error
    }
  } else {
    console.warn('Service Workers are not supported in this browser')
    return null
  }
}

export const unregisterServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready
      const success = await registration.unregister()
      console.log('Service Worker unregistered:', success)
      return success
    } catch (error) {
      console.error('Service Worker unregistration failed:', error)
      throw error
    }
  }
  return false
}

export const checkServiceWorkerUpdate = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready
      await registration.update()
      console.log('Service Worker update check completed')
    } catch (error) {
      console.error('Service Worker update check failed:', error)
    }
  }
}
